import { useQuery } from "react-query";

import { GetPricingPlanInfoResponseDTO } from "../get-pricing-plan-info/dto";

export const getPricingPlanInfoForAllWorkspacesUrl = `billing/subscription/info`;

export const useGetPricingPlanInfoForAllWorkspaces = () => {
  return useQuery<GetPricingPlanInfoResponseDTO[]>([getPricingPlanInfoForAllWorkspacesUrl]);
};
